<template>
	<div>		
		<div v-if="this.status == 'approved'" class="d-flex text-center">			
			<div v-if="this.actionMsg" style="cursor:pointer;">
				<vx-tooltip :text="`${this.actionMsg}`" position="bottom" >
					<div class="badge badge--success inline">Active</div>
				</vx-tooltip>
			</div>
			<div v-else class="badge badge--success inline">Active</div>
		</div>
		<div v-if="this.status == 'active'" class="d-flex text-center">			
			<div class="badge badge--success inline">Active</div>
		</div>
		<div v-if="this.status == 'extended' && this.actionMsg !== null" class="d-flex text-center" style="cursor:pointer;">			
			<vx-tooltip :text="`${this.actionMsg}`" position="bottom">
				<div class="badge badge--dark inline">Extended</div>
			</vx-tooltip>
		</div>
		<div v-if="this.status == 'approval pending' || this.status == 'approval-pending'" class="d-flex text-center">
			<div class="badge badge--primary inline">Approval Pending</div>
		</div>
		<div v-if="this.status == 'creation pending' || this.status == 'creation-pending'" class="d-flex text-center">
			<div class="badge badge--dark inline">Creation Pending</div>
		</div>
		<div v-if="this.status == 'rejected'" class="d-flex text-center" style="">
			<vx-tooltip :text="`${this.rejectMsg}`" position="bottom">
				<div class="badge badge--danger inline">Rejected</div>
			</vx-tooltip>
		</div>
		<div v-if="this.status == 'new approved'" class="d-flex text-center">
			<div class="badge badge--warning inline">New Approved</div>
		</div>
		<div v-if="this.status == 'error'" class="d-flex text-center" style="cursor:pointer;">			
			<vx-tooltip :text="`${this.errorMsg || 'Tucows API Failed'}`" position="bottom">
				<div class="badge badge--danger inline">Error</div>
			</vx-tooltip>
		</div>	
		<div v-if="this.status == 'updated'" class="d-flex text-center">
			<div class="badge badge--success inline">Updated</div>
		</div>
		<div v-if="this.status == 'scheduled'" class="d-flex text-center">
			<div class="badge badge--warning inline">Scheduled</div>
		</div>
		<div v-if="this.status == 'expired'" class="d-flex text-center">
			<div class="badge badge--danger inline">Expired</div>
		</div>
		<div v-if="this.status == 'expiring'" class="d-flex text-center">
			<div class="badge badge--danger inline">Expiring</div>
		</div>
		<div v-if="this.status == 'edit pending' || this.status == 'edit-pending'" class="d-flex text-center">
			<div class="badge badge--primary inline">Edit Pending</div>
		</div>
		<div v-if="this.status == 'edit approved'" class="d-flex text-center">
			<div class="badge badge--warning inline">Edit Approved</div>
		</div>				
	</div>
	
</template>

<script>
	
	export default {
		name: 'CellRendererActions',	 
		data() {
			return {  				 
			}
		},
        computed: {  
			status() {
				return this.params && this.params.data ? this.params.data.status : ''
			},
			errorMsg() {
				return this.params && this.params.data ? this.params.data.cnic_message : ''
			},
			actionMsg() {
				return this.params && this.params.data ? this.params.data.action_message : ''
			},
			rejectMsg() {
				return this.params && this.params.data ? this.params.data.rejected_comments : ''
			}
		},
	}
</script>
<style lang="scss">
    .disabled{
		pointer-events: none;
        opacity: 0.4;
	}
	.vs-tooltip {
		text-align: center;
	}
</style>